import React from "react";
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext';
import { altText, imgSize, imgCDN } from '~/utils/helpers'
import useAnalytics from '~/utils/analytics'

import FavProd from '~/components/shared/fav-prod'

import * as styles from "~/styles/tiles/tile.module.scss"


const TilePage = ({ product, tile_ind, page_type=false }) => {
  const { analytics, setAnalytics, customer } = useTheme()
  const { elev_select, ga_tile_click } = useAnalytics()
  
  const { title, handle, first_product_price, first_full_price, percent_off, 
    color, image, media, alt_cuts } = product

  let pl_name = product.pl_name
  if (!pl_name) pl_name = product?.product_line?.name || null

  const is_gift = product.pl_pima === 99999 
  const colors = []
  // const [activeColor, setActiveColor] = useState( (color && color.name) ? color.name : null);
  let activeColor = product.clr
  if (!activeColor) activeColor = (color && color.name) ? color.name : color ? color : null
  const price = product.price ? product.price : first_product_price

  const handleSelect = () => {
    ga_tile_click(product, tile_ind, 'pdp recommendation')
    elev_select(product, tile_ind, page_type)
    if (page_type === 'pdp recommendation') {
      setAnalytics({...analytics, list: 'pdp recommendation'})
    }
    if (page_type === 'last viewed products' && sessionStorage.getItem('wxsell')) {
      window._conv_q = window._conv_q || []
      window._conv_q.push(["triggerConversion", "100434687"])
    }
  }
  
  // const first_img = media && media.length && media.filter(x => !!x).find(x => x.type === 'IMAGE')
  let first_img = (typeof image !== 'undefined') ? image : false

  if (!first_img && (media && media.length > 0)) {
    let images = media.filter(x => !!x).find(x => x.type === 'IMAGE')
    if (images) first_img = images.src
    if (!images) first_img = media[0].image
  }
  
  first_img = first_img ? imgCDN(first_img) : false

  return (
    <div 
      className={[styles.tile, styles.page_tile].join(' ')}
      id={product.id}
      handle={product.handle}
      style={{opacity: '1' }} 
    >
      <>
        <meta itemProp="name" content={title} />
        <meta itemProp="url" content={`https://www.buckmason.com/products/${handle}`} />
        {media && media.length && media.filter(x => !!x).find(x => x.type === 'IMAGE') && (
          <meta itemProp="image" content={media.filter(x => !!x).find(x => x.type === 'IMAGE').src} />
        )}
      </>

      <div className={styles.images} style={{aspectRatio: '1 / 1.333 auto'}}>
        
        {(first_img) && (
          <Flink 
            href={`/products/${handle}`} 
            className={[styles.tile_link, styles.tile_title].join(' ')} 
            onClick={(e)=> handleSelect()}
          >
            <img 
              src={imgSize(first_img,700)} 
              style={{height: 'auto', left: '0', position: 'absolute', top: '0', width: '100%'}} 
              alt={altText(first_img.alt, title)}
              width={300}
              height={400}
            />
          </Flink>
        )}

        {alt_cuts && (
          <div className={styles.alts}>
            {alt_cuts.opts.length} {alt_cuts.type}s
          </div>
        )}

      </div>

      <div className={styles.infos} tile-infos="">
        <div className={styles.info}>
          {product.pl_pima !== 99998 ? (
            <>
              <Flink 
                href={`/products/${handle}`} 
                className={[styles.tile_link, styles.tile_title].join(' ')} 
                onClick={(e)=> handleSelect()}
              >
                {pl_name ? pl_name : title}
              </Flink>
              <div data-product-price="" className={styles.price} data-price-wrapper="">
                {percent_off ? (
                  <>
                    <span className={styles.ptPricePercent}>
                      ({percent_off}% OFF)
                    </span>
                    <span className={styles.ptPriceLow}>
                      ${first_product_price}
                    </span>
                    <span className={styles.ptPriceFull}>
                      ${first_full_price}
                    </span>
                  </>
                ) : (
                  <span>${price}</span>
                )}
              </div>
            </>
          ) : (
            <>&nbsp;</>
          )}
        </div>

        {(customer && localStorage.getItem('ward')) && (
          <FavProd prod_id={product.mid} tile={true} />
        )}

        {!is_gift && activeColor && (
          <div className={[styles.info, styles.color].join(' ')} tile-color="">
            {activeColor}
          </div>
        )}
          
        {!is_gift && !handle.includes('candle') && colors.length > 0 && (
          <div className={styles.info} tile-colors="">
            {colors.length} Color{colors.length > 1 ? 's' : ''}
          </div>
        )}

      </div>
    </div>
  )
}

export default TilePage



